/** Match legacy keys — existing carts remain valid after migration. */
export const CART_STORAGE_KEY = 'modamai-cart';
export const CART_SESSION_STORAGE_KEY = 'modamai-cart-session-id';
export const WISHLIST_STORAGE_KEY = 'modamai-wishlist-ids';
